import React from 'react';
import { Button, Text } from '@fluentui/react-components';
import {
  BroomRegular,
  DataAreaRegular,
  MathFormulaRegular,
  BrainRegular,
} from '@fluentui/react-icons';
import type { PageId } from '../App';

interface StartPageProps {
  onNavigate: (page: PageId) => void;
}

export const StartPage: React.FC<StartPageProps> = ({ onNavigate }) => (
  <div>
    <div className="card">
      <Text className="section-title">Demarrer</Text>
      <Text size={300} style={{ display: 'block', marginBottom: 6 }}>
        Choisissez l'action la plus utile pour commencer rapidement.
      </Text>
      <Text size={200} style={{ color: 'var(--text-secondary)' }}>
        Vous pouvez ensuite acceder a toutes les autres options via l'onglet Plus.
      </Text>
    </div>

    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 10,
      }}
    >
      <StartCard
        title="Nettoyer"
        description="Corriger format, espaces, doublons et qualite des donnees."
        icon={<BroomRegular />}
        onClick={() => onNavigate('cleaning')}
      />
      <StartCard
        title="Analyser"
        description="Analyser le dataset et obtenir KPIs, tendances et anomalies."
        icon={<DataAreaRegular />}
        onClick={() => onNavigate('analysis')}
      />
      <StartCard
        title="Formule"
        description="Generer ou expliquer une formule Excel."
        icon={<MathFormulaRegular />}
        onClick={() => onNavigate('formulas')}
      />
      <StartCard
        title="Audit Classeur"
        description="Analyser dependances, risques et performance du classeur."
        icon={<BrainRegular />}
        onClick={() => onNavigate('workbook-brain')}
      />
    </div>
  </div>
);

const StartCard: React.FC<{
  title: string;
  description: string;
  icon: React.ReactElement;
  onClick: () => void;
}> = ({ title, description, icon, onClick }) => (
  <div className="card" style={{ marginBottom: 0 }}>
    <Text size={300} weight="semibold" style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
      {icon}
      {title}
    </Text>
    <Text size={200} style={{ color: 'var(--text-secondary)', display: 'block', marginBottom: 10 }}>
      {description}
    </Text>
    <Button appearance="primary" size="small" onClick={onClick}>
      Ouvrir
    </Button>
  </div>
);
